import api from "./api";

const StockInReportService = {
  getReport: async (params) => {
    const response = await api.get("/stockInReport/getReport", {
      params: {
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
        projectCategoryId: params.projectCategoryId || undefined,
        projectId: params.projectId || undefined,
        storeId: params.storeId || undefined,
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        itemCategoryId: params.itemCategoryId || undefined,
        itemId: params.itemId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        status: params.status || undefined,
        page: params.page || 1,
        limit: params.limit || 10,
      },
    });

    return response.data;

  },

  getApprovedSummaryReport: async (params) => {
    const response = await api.get("/stockInReport/summary", {
      params: {
        companyId: params.companyId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
        projectCategoryId: params.projectCategoryId || undefined,
        projectId: params.projectId || undefined,
        storeId: params.storeId || undefined,
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        itemCategoryId: params.itemCategoryId || undefined,
        itemId: params.itemId || undefined,
        startDate: params.startDate || undefined,
        endDate: params.endDate || undefined,
        status: params.status || "All",
        page: params.page || 1,
        limit: params.limit || 1000,
      },
    });

    return response.data;
  },

  getVendors: async (params = {}) => {
    const res = await api.get("/stockInReport/vendors", {
      params: {
        companyId: params.companyId || undefined,
        projectId: params.projectId || undefined,
      },
    });
    return res.data;
  },

  getVendorsByProject: async (projectId, params = {}) => {
    const res = await api.get(
      `/stockInReport/vendorsByProject/${projectId}`,
      {
        params: {
          companyId: params.companyId || undefined,
        },
      }
    );

    return res.data;
  },

  getSupplierLocationsByVendor: async (vendorId, params = {}) => {
    const queryParams =
      typeof params === "object" && params !== null
        ? {
            projectId: params.projectId || undefined,
            companyId: params.companyId || undefined,
          }
        : { projectId: params || undefined };

    const res = await api.get(`/stockInReport/supplierLocations/${vendorId}`, {
      params: queryParams,
    });
    return res.data;
  },

  getProjectCategories: async (params = {}) => {
    const res = await api.get("/stockInReport/projectCategories", {
      params: {
        companyId: params.companyId || undefined,
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
      },
    });
    return res.data;
  },

  getProjects: async (params = {}) => {
    const res = await api.get("/stockInReport/projects", {
      params: {
        companyId: params.companyId || undefined,
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        projectCategoryId: params.projectCategoryId || undefined,
        employeeId: params.employeeId || undefined,
        roleId: params.roleId || undefined,
      },
    });
    return res.data;
  },

  getItemCategories: async (params = {}) => {
    const res = await api.get("/stockInReport/itemCategories", {
      params: {
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        projectId: params.projectId || undefined,
        companyId: params.companyId || undefined,
      },
    });
    return res.data;
  },

  getItemCategoriesByProject: async (projectId, params = {}) => {
    const res = await api.get(`/stockInReport/itemCategories/${projectId}`, {
      params: {
        vendorId: params.vendorId || undefined,
        vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
        companyId: params.companyId || undefined,
      },
    });
    return res.data;
  },

  getItemsByCategory: async (itemCategoryId, params = {}) => {
    const queryParams =
      typeof params === "object" && params !== null
        ? {
            projectId: params.projectId || undefined,
            vendorId: params.vendorId || undefined,
            vendorStoreId: params.vendorStoreId || params.supplierLocationId || undefined,
            companyId: params.companyId || undefined,
          }
        : { projectId: params || undefined };

    const res = await api.get(`/stockInReport/itemsByCategory/${itemCategoryId}`, {
      params: queryParams,
    });
    return res.data;
  },
};

export default StockInReportService;
